import React, { useState } from 'react';
import { CalendarPlus, ChevronDown } from 'lucide-react';
import { CalEvent, googleCalUrl, outlookUrl, yahooUrl, downloadIcs } from '../utils/addToCalendar';

/** "Add to Calendar" button → menu of Google / Apple / Outlook / Yahoo / .ics. Drop it on any
 *  booking-confirmation screen; pass the booked appointment as a CalEvent. (Jose 2026-10-29) */
export const AddToCalendar: React.FC<{ event: CalEvent; className?: string }> = ({ event, className = '' }) => {
  const [open, setOpen] = useState(false);
  const row = 'flex items-center gap-3 w-full px-4 py-3 text-left text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors';
  const close = () => setOpen(false);

  return (
    <div className={`relative ${className}`}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-center gap-2 py-3 border-2 border-slik-purple text-slik-purple rounded-button font-bold hover:bg-slik-purple/5 transition-colors"
      >
        <CalendarPlus className="w-5 h-5" /> Add to Calendar
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-10" onClick={close} />
          <div className="absolute z-20 left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-200 overflow-hidden divide-y divide-gray-100">
            <a className={row} href={googleCalUrl(event)} target="_blank" rel="noopener noreferrer" onClick={close}>
              <span className="w-5 text-center">📅</span> Google Calendar
            </a>
            <button type="button" className={row} onClick={() => { downloadIcs(event); close(); }}>
              <span className="w-5 text-center"></span> Apple Calendar
            </button>
            <a className={row} href={outlookUrl(event)} target="_blank" rel="noopener noreferrer" onClick={close}>
              <span className="w-5 text-center">📧</span> Outlook
            </a>
            <a className={row} href={yahooUrl(event)} target="_blank" rel="noopener noreferrer" onClick={close}>
              <span className="w-5 text-center">🟣</span> Yahoo
            </a>
            <button type="button" className={row} onClick={() => { downloadIcs(event); close(); }}>
              <span className="w-5 text-center">⬇️</span> Download (.ics)
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default AddToCalendar;
